import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal, Spinner, Table } from 'react-bootstrap';
import axios from 'axios';

export default function AdminConnectionGrantsModal({ entity, onClose }) {
  const [data, setData] = useState(null);
  const [drafts, setDrafts] = useState({});
  const [reasons, setReasons] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(null);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const endpoint = '/api/admin/entidades/' + entity.id + '/connection-grants';

  useEffect(() => {
    let active = true;
    axios.get(endpoint).then(response => {
      if (!active) return;
      setData(response.data);
      setDrafts(Object.fromEntries(response.data.items.map(item => [item.key, item.manual])));
    }).catch(err => {
      if (active) setError(err.response?.data?.message || 'Não foi possível carregar as conexões.');
    }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [endpoint]);

  const save = async item => {
    setSaving(item.key);
    setError('');
    setNotice('');
    try {
      const response = await axios.put(endpoint + '/' + item.key, {
        quantity: Number(drafts[item.key]), previous_quantity: item.manual, reason: reasons[item.key].trim(),
      });
      setData(response.data);
      setReasons(current => ({ ...current, [item.key]: '' }));
      setNotice('Liberação atualizada. Nenhuma cobrança foi gerada.');
    } catch (err) {
      setError(err.response?.data?.message || 'Não foi possível salvar a liberação.');
    } finally { setSaving(null); }
  };

  return <Modal show onHide={() => !saving && onClose()} size="xl" backdrop="static">
    <Modal.Header closeButton={!saving}><Modal.Title>Conexões — {entity.nome}</Modal.Title></Modal.Header>
    <Modal.Body>
      <p>Libere conexões extras sem cobrança. Elas são somadas às incluídas e às compradas, permanecendo disponíveis até você alterar esta liberação.</p>
      {error && <Alert variant="danger">{error}</Alert>}
      {notice && <Alert variant="success">{notice}</Alert>}
      {loading ? <Spinner animation="border" role="status"><span className="visually-hidden">Carregando conexões</span></Spinner> : data && <>
        <Table responsive bordered className="align-middle">
          <thead><tr><th>Conexão</th><th>Incluídas</th><th>Compradas</th><th>Extras manuais</th><th>Total após salvar</th><th>Em uso</th><th>Motivo e ação</th></tr></thead>
          <tbody>{data.items.map(item => {
            const value = drafts[item.key];
            const quantity = Number(value);
            const total = item.included + item.purchased + quantity;
            const invalid = value === '' || !Number.isInteger(quantity) || quantity < 0 || quantity > 10000 || (quantity < item.manual && total < item.used);
            return <tr key={item.key}>
              <td>{item.name}</td><td>{item.included}</td><td>{item.purchased}</td>
              <td><Form.Control aria-label={'Extras manuais: ' + item.name} type="number" min="0" max="10000" step="1" value={value} disabled={Boolean(saving)} isInvalid={invalid} onChange={e => setDrafts(current => ({ ...current, [item.key]: e.target.value }))} style={{ minWidth: 90 }} /><Form.Control.Feedback type="invalid">Use uma quantidade inteira que mantenha o limite suficiente para as conexões em uso.</Form.Control.Feedback></td>
              <td>{invalid ? '—' : total}</td><td>{item.used}</td>
              <td style={{ minWidth: 240 }}><Form.Control aria-label={'Motivo: ' + item.name} as="textarea" rows={2} maxLength={1000} placeholder="Motivo da alteração" value={reasons[item.key] || ''} disabled={Boolean(saving)} onChange={e => setReasons(current => ({ ...current, [item.key]: e.target.value }))} /><Button className="mt-2" size="sm" disabled={Boolean(saving) || invalid || quantity === item.manual || !reasons[item.key]?.trim()} onClick={() => save(item)}>{saving === item.key ? 'Salvando...' : 'Salvar liberação'}</Button></td>
            </tr>;
          })}</tbody>
        </Table>
        <h5 className="mt-4">Histórico de liberações</h5>
        <p className="text-muted small">Últimas 100 alterações administrativas desta entidade.</p>
        {data.history.length ? <Table responsive size="sm"><thead><tr><th>Data</th><th>Conexão</th><th>Extras manuais</th><th>Administrador</th><th>Motivo</th></tr></thead><tbody>{data.history.map(event => <tr key={event.id}><td>{new Date(event.created_at.replace(' ', 'T')).toLocaleString('pt-BR')}</td><td>{event.addon_name}</td><td>{event.previous_quantity} → {event.new_quantity}</td><td>{event.actor_name || 'Administrador removido'}</td><td style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{event.reason}</td></tr>)}</tbody></Table> : <p className="text-muted">Nenhuma liberação manual registrada.</p>}
      </>}
    </Modal.Body>
    <Modal.Footer><Button variant="secondary" disabled={Boolean(saving)} onClick={onClose}>Fechar</Button></Modal.Footer>
  </Modal>;
}
